<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </div>
</template>

<script setup>
import { useCurrentUser, useFirebaseApp } from 'vuefire'
import { watch } from 'vue'
import { getFirestore, collection, query, where, getDocs, setDoc, increment } from 'firebase/firestore'

const user = useCurrentUser()
const app = useFirebaseApp()
const db = getFirestore(app)

watch(user, async (newUser, oldUser) => {
  if (newUser) {
    // User is logged in (either newly manually logged in or auto-logged in via persistence)
    const sessionCounted = sessionStorage.getItem('sessionLoginCounted')

    if (!sessionCounted) {
      try {
        const userQuery = query(collection(db, 'user'), where('userName', '==', newUser.email))
        const userSnapshot = await getDocs(userQuery)

        if (!userSnapshot.empty) {
          const userDocRef = userSnapshot.docs[0].ref
          // setDoc with merge: true ensures that if the field doesn't exist, it's created and set to 1.
          await setDoc(userDocRef, {
            numberofLogins: increment(1)
          }, { merge: true })
          
          sessionStorage.setItem('sessionLoginCounted', 'true')
          console.log('Login tracked successfully.')
        } else {
          console.warn('Could not find user document to track login.')
        }
      } catch (err) {
        console.error('Error tracking login:', err)
      }
    }
  } else if (!newUser && oldUser) {
    // User logged out
    sessionStorage.removeItem('sessionLoginCounted')
  }
}, { immediate: true }) // immediate: true executes the watcher immediately with the current value
</script>
